export enum SupportedChainId {
  MAINNET = 1,
  GOERLI = 5,
  BNB = 56,
  BNB_TEST = 97,
}
